import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { motion } from "framer-motion";

const axios = require("axios").default;

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("E-Mail entered is not valid")
    .required("E-Mail is required"),
});

function ForgotPassword() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  return (
    <div className="h-screen flex items-center pb-32">
      <Formik
        initialValues={{
          email: "",
        }}
        validationSchema={ForgotPasswordSchema}
        onSubmit={(values) => {
          axios
            .post(
              "https://application-flashcards.herokuapp.com/api/users/forgotpassword",
              {
                ...values,
              }
            )
            .then(function (response) {
              setSuccess(
                "Link successfully sent to e-mail! Check e-mail provided to proceed."
              );
            })
            .catch(function (error) {
              setError(error.response.data.message);
            });
        }}
      >
        {({ errors, touched }) => (
          <Form className="border border-slate-300 w-4/12 rounded-sm p-5 px-20 m-auto py-10 sm:w-10/12 md:w-8/12 md:px-5 md:mx-auto xl:w-6/12">
            <h2 className="text-2xl font-semibold mb-2 text-stone-700">
              Forgot Password
            </h2>
            <div className="flex justify-between">
              <label htmlFor="email" className="my-2">
                E-Mail:
              </label>
              {errors.email && touched.email ? (
                <p className="pt-2 text-md font-thin text-red-500">
                  {errors.email}
                </p>
              ) : null}
            </div>
            <Field
              id="email"
              placeholder=" Enter E-Mail Here"
              type="text"
              name="email"
              className="border border-slate-400 py-1 w-full"
            />
            {error ? (
              <p className="pt-2 text-md font-thin text-red-500">
                Server Error: {error}
              </p>
            ) : null}
            <div className="flex justify-end mt-1">
              <button
                className="text-white bg-sky-400 border-solid border border-neutral-50 rounded p-1 hover:bg-sky-500"
                type="submit"
              >
                Submit
              </button>
            </div>
            {success ? (
              <p className="text-green-400 text-sm">{success}</p>
            ) : null}
          </Form>
        )}
      </Formik>
      <div
        className="absolute bottom-0 py-12 flex justify-center w-full text-3xl font-semibold"
        style={{ backgroundColor: "rgba(255,255,255,0.1)" }}
      >
        <button
          onClick={() => {
            navigate("/login");
          }}
        >
          flashcards
        </button>
      </div>
    </div>
  );
}

export default ForgotPassword;
